import { useState } from "react";
import { MessagesSquare } from "lucide-react";
import { PageHeader } from "@/components/control/PageHeader";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Section, Loadable, Empty, Status, Tabbar, TabPanel, useTabs, RowLink, TextField, useLoad, fmt } from "@/components/control/kit";

const TABS = [
  { value: "all", label: "Alle" }, { value: "sichtbar", label: "Sichtbar" }, { value: "ausgeblendet", label: "Ausgeblendet" },
  { value: "entfernt_moderation", label: "Von Moderation entfernt" }, { value: "entfernt_autor", label: "Von Verfasser:in entfernt" },
];

export const audienceText = (a) => (a?.type === "group" ? `Kreis: ${a.group_name || "unbekannt"}` : "Ganze Community");

function PostTable({ posts }) {
  return (
    <div className="overflow-x-auto">
      <Table data-testid="community-table">
        <TableHeader><TableRow>
          <TableHead>Beitrag</TableHead><TableHead>Verfasser:in</TableHead><TableHead>Zielgruppe</TableHead>
          <TableHead>Kommentare</TableHead><TableHead>Offene Meldungen</TableHead><TableHead>Status</TableHead><TableHead>Erstellt</TableHead>
        </TableRow></TableHeader>
        <TableBody>
          {posts.length === 0 && <TableRow><TableCell colSpan={7}><Empty text="Keine Beiträge in dieser Ansicht." /></TableCell></TableRow>}
          {posts.map((p) => (
            <TableRow key={p.id} data-testid={`community-row-${p.id}`}>
              <TableCell className="max-w-md">
                <RowLink to={`/community-beitraege/${p.id}`} testId={`community-link-${p.id}`}>{p.excerpt || "(ohne Text)"}</RowLink>
              </TableCell>
              <TableCell className="text-sm">{p.author?.name || "–"}</TableCell>
              <TableCell className="text-sm">{audienceText(p.audience)}</TableCell>
              <TableCell className="text-sm">{p.comments_count}</TableCell>
              <TableCell className={`text-sm ${p.open_reports ? "font-semibold text-red-700" : ""}`}>{p.open_reports}</TableCell>
              <TableCell><Status value={p.status} /></TableCell>
              <TableCell className="whitespace-nowrap text-sm">{fmt(p.created_at)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}

export default function CommunityPosts() {
  const [status, setStatus] = useState("all");
  const [q, setQ] = useState("");
  const st = useLoad(`/community/posts?status=${encodeURIComponent(status)}&q=${encodeURIComponent(q)}`);
  const c = st.data?.counts || {};
  const tabs = useTabs(TABS.map((t) => ({ ...t, count: t.value === "all" ? undefined : c[t.value] || 0 })), status);
  return (
    <div>
      <PageHeader title="Community-Beiträge" subtitle="Beiträge und Kommentare der Mitglieder-App prüfen, begründet ausblenden oder wiederherstellen." icon={MessagesSquare} />
      <Tabbar tabs={tabs} onChange={setStatus} testId="community-status-tabs" />
      <TextField id="community-search" label="Im Text suchen" value={q} onChange={setQ} testId="community-search" className="mb-4 max-w-sm" />
      <TabPanel tabs={tabs} testId="community-status-tabs-panel">
        <Section title="Beiträge" testId="community-section">
          <Loadable state={st}>{(d) => <PostTable posts={d.posts} />}</Loadable>
        </Section>
      </TabPanel>
    </div>
  );
}
